import axios from '@/libs/api.request'

const getVersion = () => {
  return axios.request({
    url: `/version.json`,
    method: 'get',
    data: {
      _t: new Date().valueOf()
    },
    headers: {
      noEncryption: true
    }
  })
}

class VersionCheck {
  async checkVersion() {
    // let versionData = await getVersion()
    // console.log('versionData', versionData)
    if (versionData.data && versionData.data.data) {
      let version = versionData.data.data
      // console.log('当前版本号common.js：', version)
      let useVersion = sessionStorage.getItem('version')
      // console.log('当前版本号app.vue：', useVersion)
      if (!useVersion) {
        sessionStorage.setItem('version', version)
      } else {
        if (useVersion != version) {
          // console.log('发现最新版本')
          // alert('发现')
          sessionStorage.setItem('version', version)
          // console.log('刷新页面', version, sessionStorage.getItem('version'))
          location.reload(true)
        }
      }
    }
  }
}

export default new VersionCheck()
